import {capitalize} from 'lodash';

export const includesIgnoreCase = (value: string, searchValue: string) => {
  return value?.toLowerCase().includes(searchValue?.toLowerCase());
};

export const formatEnum = (enumValue: string) => {
  return capitalize(enumValue)?.replaceAll('_', ' ');
};
